import { keyframes } from '@mui/material/styles';

const bounceFrames = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-4px);
  }
  60% {
    transform: translateY(-2px);
  }
`;

export const bounce = `${bounceFrames} 1.5s ease-in-out infinite`;
